import React, { useEffect, useState } from "react";
import "./App.css";
import AppRouter from "./routers/appRouter";
import { ConfigProvider, Spin } from "antd";
import { useSettings } from "./contexts/settingsContext";
import { UserProvider } from "./contexts/userContext";
import { fetchAndSetCompetition } from "./helpers/fetchAndSetCompetition";
import { fetchAndSetSettings } from "./helpers/fetchAndSetSettings";
import { fetchAndSetImagePath } from "./helpers/fetchAndSetImagePath"; // Import the new helper    

const themeSettings = {
	token: {
		colorPrimary: "#1271dd",
	},
};

function App() {
	const { state: settings, dispatch } = useSettings();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const initializeApp = async () => {
			await fetchAndSetImagePath(dispatch); // Fetch and set the image path    

			const asd = await fetchAndSetCompetition(dispatch);
			const selectedCompetition = JSON.parse(localStorage.getItem('selectedCompetition'));
			if (selectedCompetition) {
				await fetchAndSetSettings(dispatch, selectedCompetition._id);
			}

			setLoading(false); // Set loading to false after settings are fetched    
		};
		initializeApp();
	}, [dispatch]);

	if (loading) {
		return (
			<div className="spin-wrapper">
				<Spin />
			</div>
		);
	}

	return (
		<ConfigProvider theme={themeSettings}>
		<UserProvider>
			<AppRouter />
		</UserProvider>
		</ConfigProvider>
	);
}

export default App;  
